import { FLAGS } from 'config/flags'
import useSession from './useSession'

const useFlags = () => {

  const { user } = useSession()

  const {
    isCreatorsEnabled,
  } = FLAGS
  
  return {
    ...FLAGS,
    isCreatorsEnabled: isCreatorsEnabled && user?.isSerieCreator,
  }
}

export default useFlags